import { render } from "./edit.vue?vue&type=template&id=218f38bb&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=218f38bb&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-218f38bb"],['__file',"src/views/advert/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "218f38bb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('218f38bb', __exports__)) {
    console.log('reload')
    api.reload('218f38bb', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=218f38bb&scoped=true", () => {
    console.log('re-render')
    api.rerender('218f38bb', render)
  })

}


export default __exports__